<div id="form" class="login-body" *ngIf="!loadingFromProxy">
    <div class="col-md-12 Marquee">
        <marquee *ngIf="instanceName != '' && instanceName != undefined && instanceName != null"><span>{{instanceName}}</span></marquee>
    </div>
    <div class="login-panel ui-fluid Custompanel">
        <div class="BioPharmaLogo" >
            <!--<a [routerLink]="['/login']" class="login-logo">-->
                <img src="{{baseUrl}}/assets/content/logo/{{landinglogo}}"/>
            <!--</a>-->
        </div>
        <!-- /.login-logo -->
        <div class="login-panel-content">
            <h1 class="login-box-msg paraHeader">Login</h1>
            <form name="form" (ngSubmit)="loginForm.form.valid && loginSubmit()" #loginForm="ngForm" novalidate>
                <div style="position: relative;">    
                <div class="emptyRow">User Name</div>
                <div class="form-group has-feedback" [ngClass]="{ 'has-error': loginForm.submitted && !username.valid }">
                    <input type="text" [setelementautofocus] class="form-control" name="username"
                     [(ngModel)]="loginDetail.UserName" #username="ngModel" required placeholder="" 
                     autocomplete="off"  style="width:90%;padding-left: 32px;" />
                    <span class="glyphicon glyphicon-user form-control-feedback"></span>
                </div>

                <div class="form-group">
                    <div *ngIf="loginForm.submitted && !username.valid" class="has-error"> - User Name is required</div>
                </div>

                <div class="popover__wrapper">
                  

                        <div class="popover__title" *ngIf="usernameInfoIcon">
                         <span class="glyphicon glyphicon-info-sign"></span>
                            <!-- Info -->
                        </div>
                   
                    <div class="popover__content" >
                        <p class="popover__message">
                            <ul class="list-unstyled">
                                <li><span class="fa fa-caret-right">&nbsp;</span>User Name should be your registered Email-Id</li>
                            </ul>
                    </div>
                </div>
            </div>

               
                <div class="emptyRow">Password</div>
                <div class="form-group has-feedback" [ngClass]="{ 'has-error': loginForm.submitted && !password.valid }">
                    <input type="password" autocomplete="off" class="form-control" 
                    name="password" [(ngModel)]="loginDetail.Password" #password="ngModel" 
                    required placeholder="" autocomplete="off" style="width:90%;padding-left: 32px;"/>
                    <span class="glyphicon glyphicon-lock form-control-feedback"></span>
                </div>
                <div class="form-group">
                    <div *ngIf="loginForm.submitted && !password.valid" class="has-error"> - Password is required</div>
                </div>
               
                <div class="form-group">
                    <div style="display: none" id="login-alert" class="alert alert-danger col-sm-12"></div>
                </div>
                <div class="form-group">
                    <div *ngIf="showCaptcha" class="row" style="margin-left: 0px;">
                        <re-captcha
                            [siteKey]="captchaSiteKey"
                            required
                            (resolved)="handleCorrectCaptcha($event)">
                        </re-captcha>
                    </div>
                </div>
                <div class="row">
                    <!-- /.col -->
                    <div class="col-xs-8 pull-left" *ngIf="forgotPasswordBtn" >
                      <a [routerLink]="['/','forgotpassword']" >Forgot Password</a>
                    </div>
                    <div class="col-xs-4 pull-right">
                        <button type="submit" [disabled]="loading"  class="btn RegisterBtn" title="Login" name="login">&nbsp;Login</button>&nbsp;
                    </div>
                    <!-- /.col -->
                </div>
            </form>
        </div>
        <!-- /.login-box-body -->       
    </div>
    <!-- /.login-box -->
</div>

<p-dialog header="Password Expiry!" closable="false" [(visible)]="display" id="pwdExpiry" modal="true" showEffect="bounce" [draggable]="false" position="center">
    {{ expiryMessage }}
    <footer style="margin-top: 10px;">
        <div class="col-xs-3 pull-right" *ngIf="cancelButton">
            <button type="button" class="btn RegisterBtn"  (click)="routeToLandingCancel()" label="Cancel">&nbsp;CANCEL</button>
        </div>
        <div class="col-xs-3 pull-right" [ngStyle]="{'margin-right':cancelButton ? '35px' : '46px'}">
            <button type="button" class="btn RegisterBtn" (click)="routeToLanding()" label="Ok">&nbsp;Change Password</button>
        </div>
    </footer>
</p-dialog>


<p-dialog header="Logged out!" closable="false" [(visible)]="displayTnC" id="TnC" modal="true" resizable="false" showEffect="explode" [draggable]="false" position="center">
    <p>You have been logged out of the system, as you did not accept the Terms and Conditions of our site.</p>
    <footer>
        <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
            <span id="btn-login"><button type="button" class="btn btn-success btn-lg" (click)="logout()">OK</button></span>&nbsp;&nbsp;
        </div>
    </footer>
</p-dialog>
<div class="blockUIDialog" *ngIf="loading" role="dialog">
    <div class="splash-screen">
        <div class="splash-loader-container">
            <!-- <svg class="splash-loader" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
               <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
            </svg> -->
            <p-progressSpinner strokeWidth="3"></p-progressSpinner>
        </div>
    </div>
</div>
<div *ngIf="loadingFromProxy" class="img-responsive">
    <div class="cssload-spin-box"></div>
</div>
